import React from 'react';
import PropTypes from 'prop-types';
import SearchPage from '../components/Views/SearchPage';
import { getDataForTransformationsQuery } from '../queries';
import {
  SearchItemsTitleService,
  SearchItemsH1Service,
  fromUrlToObj,
  getSeoData,
  getValueFromObject,
  adaptFiltersForState
} from '../utils/helpers';
import i18n from '../utils/i18n';
import Layout from '../components/Layout/Layout';
import {
  setChosenLocationNames,
  setCurrentState,
  setLocationIds,
  setSearchSort
} from '../actions';

const Search = ({ transformedObj, seoData }) => {
  return <SearchPage transformedObj={transformedObj} h1={seoData.h1} />;
};

Search.getInitialProps = async ({
  apolloClient,
  asPath,
  query,
  res,
  req,
  store
}) => {
  const dataForTransform = await apolloClient.query({
    query: getDataForTransformationsQuery
  });
  const transformedObj = fromUrlToObj(dataForTransform, query);

  if (res && transformedObj.noMatch) {
    res.statusCode = 404;

    return {
      statusCode: 404
    };
  }
  const locationsIds = transformedObj.filter.locationIds || [];
  const storedFormState = store.getState().searchForm.currentState;
  const objForStore = adaptFiltersForState(transformedObj?.filter);
  store.dispatch(setCurrentState({ ...storedFormState, ...objForStore }));
  // eslint-disable-next-line
  const { category_touched, ...filtersWithoutCategoryTouched } = transformedObj.filter;
  transformedObj.filter = filtersWithoutCategoryTouched;

  store.dispatch(
    setSearchSort(
      getValueFromObject(
        dataForTransform.data.sort,
        transformedObj.sorting,
        'id'
      ) || '1'
    )
  );
  store.dispatch(
    setChosenLocationNames(
      dataForTransform.data.locations
        .filter(location => locationsIds.includes(location.id))
        .map(location => location.name.trim())
    )
  );
  store.dispatch(
    setLocationIds(
      dataForTransform.data.locations
        .filter(location => locationsIds.includes(location.id))
        .map(location => location.id)
    )
  );

  const seoData = await getSeoData(apolloClient, asPath, req);

  if (!seoData.title || !seoData.description) {
    seoData.title = new SearchItemsTitleService(
      dataForTransform.data,
      transformedObj.filter,
      i18n
    ).getTitle();

    seoData.description = i18n.t('default_search_description');
  }

  if (!seoData.h1) {
    seoData.h1 = new SearchItemsH1Service(
      dataForTransform.data,
      transformedObj.filter,
      i18n
    ).getH1();
  }

  return {
    transformedObj,
    seoData
  };
};

Search.propTypes = {
  transformedObj: PropTypes.object,
  seoData: PropTypes.object
};

Search.getLayout = page => <Layout isFixedHeader={true}>{page}</Layout>;

export default Search;
